import { generateSlug } from "@/helpers/slugHelper";
import React, { useEffect, useState } from "react";
import styles from "../ProductInfo/ProductInfo.module.scss";
import Toggle from "../UiElements/Toggle";
import { priceFormatFunc } from "@/helpers/stringFormat";
/* This component will be use for Showing Product information  
   Vendor of the product and Name(title) of the product. 
*/

export default function ProductDetailsComp({
  finalProductPrice,
  cancelledProductPrice,
  productInfo,
  salePrice
}) {
  const [vendor,setVendor] = useState()

    useEffect(()=>{
      if(productInfo){
        async function getVendorName(){
          const vendorName =  await generateSlug(productInfo.vendor)
          setVendor(vendorName)
        }
        getVendorName()
      }
    },[])
  if (productInfo) {
    return (
      <>
        <div className="grid-xs-8 grid-sm-8 grid-md-9">
          <h1 className="font-unset">
              <a id="designerName" className={`x-large-xs large-sm xx-large-md ${styles.heading}`} tabIndex={0} href={vendor ? `/designer/${vendor}` : ""}>
                  {productInfo.vendor}
              </a>
              <span
                id="productName"
                className={`small-xs normal-sm large-md ${styles.sub_heading}`}
              >
                {productInfo.title}
              </span>
          </h1>
          <div id="attn-inline-price-trigger"></div>
        </div>
        <div className="grid-xs-4 grid-sm-4 grid-md-3">
          <div className="text-end large-xs normal-sm large-md ">
            <span id="productPrice" className={salePrice === undefined ? "" : "final-sale-price-color"}>
              {priceFormatFunc(finalProductPrice)}
            </span>
            <br />
            {cancelledProductPrice && (
              <span
                className="large-xs normal-sm large-md"
                id="productCancelledPrice"
              >
                <s>{cancelledProductPrice}</s>
              </span>
            )}
          </div>
        </div>
      </>
    );
  }
}
